import React from "react"
import Directory from "./components/Directory"

const Home = () => {
  return (
    <div>
      <Directory />
    </div>
  )
}

export default Home
